export { default } from './Paragraph';
export type { Props } from './Paragraph';



// WEBPACK FOOTER //
// ../kibble/components/Paragraph/index.ts